// Format a number to ~5 significant figures, locale-grouped, trimmed.
// Replaces @outcomexyz/precision's formatSigFig for our purposes.
export function formatSigFig(v: number, digits = 5): string {
  if (!isFinite(v)) return String(v);
  if (v === 0) return "0";
  const trimmed = parseFloat(v.toPrecision(digits));
  return trimmed.toLocaleString(undefined, { maximumFractionDigits: 8 });
}
